import React, { useState, useEffect } from 'react';
import { Upload, AlertCircle, Video, Image as ImageIcon, Sparkles, Download, Facebook, ArrowLeft, Trash2, CheckCircle, Clock, DollarSign, Zap, X, Check, Loader2, ZoomIn, BarChart3 } from 'lucide-react';
import { API_URL } from '../../config';
import QuotaStats from './QuotaStats';

export default function UniversalMarketing({ clientId, onBack }) {
  const [models, setModels] = useState([]);
  const [products, setProducts] = useState([]);
  const [generated, setGenerated] = useState([]);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState('manage');
  const [showDescription, setShowDescription] = useState(true);
  const [videoLoading, setVideoLoading] = useState({});
  
  const [maxModels, setMaxModels] = useState(5);
  const [maxProducts, setMaxProducts] = useState(10);
  const [canAddMoreModels, setCanAddMoreModels] = useState(true);
  const [canAddMoreProducts, setCanAddMoreProducts] = useState(true);
  
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [generatingStatus, setGeneratingStatus] = useState({});
  
  const [selectedGenerated, setSelectedGenerated] = useState([]);
  const [publishCaption, setPublishCaption] = useState('');
  const [autoPublishing, setAutoPublishing] = useState(false);
  const [quotas, setQuotas] = useState({
    max_images: 0,
    used_images: 0,
    remaining_images: 0,
    max_videos: 0,
    used_videos: 0,
    remaining_videos: 0
  });

  const [modal, setModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info',
    onConfirm: null
  });

  const [previewModal, setPreviewModal] = useState({
    isOpen: false,
    imageUrl: '',
    name: '',
    date: ''
  });

  // Modal vidéo config
  const [showVideoConfig, setShowVideoConfig] = useState(false);
  const [videoConfig, setVideoConfig] = useState({
    generated_id: null,
    with_audio: false,
    product_name: '',
    price_display: '',
    text_overlay: ''
  });

  const [showModelForm, setShowModelForm] = useState(false);
  const [showProductForm, setShowProductForm] = useState(false);
  const [videos, setVideos] = useState([]);
  
  // ✅ NOUVEAUX ÉTATS POUR FUSION ET PUBLICATION VIDÉOS
  const [selectedVideosForMerge, setSelectedVideosForMerge] = useState([]);
  const [showPublishVideoModal, setShowPublishVideoModal] = useState(false);
  const [selectedVideoForPublish, setSelectedVideoForPublish] = useState(null);
  const [videoPublishCaption, setVideoPublishCaption] = useState('');
  const [isPublishingVideo, setIsPublishingVideo] = useState(false);
  const [showTitlePriceOnImage, setShowTitlePriceOnImage] = useState(false);
  const [showTitlePriceOnVideo, setShowTitlePriceOnVideo] = useState(false);
  
  const [modelFormData, setModelFormData] = useState({
    name: '',
    file: null,
    preview: null
  });
  const [productFormData, setProductFormData] = useState({
    name: '',
    description: '',
    price: '',
    file: null,
    preview: null
  });
  const [uploadLoading, setUploadLoading] = useState(false);

  const [stats, setStats] = useState({
    totalGenerated: 0,
    thisMonth: 0,
    thisWeek: 0
  });
  // Fonction pour charger les quotas
const loadQuotas = async () => {
  try {
    const response = await fetch(`${API_URL}/api/clients/${clientId}/quotas?service=universal`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
    });
    
    if (response.ok) {
      const data = await response.json();
      setQuotas(data);
    }
  } catch (error) {
    console.error('Error loading quotas:', error);
  }
};

  const showModal = (title, message, type = 'info', onConfirm = null) => {
    setModal({ isOpen: true, title, message, type, onConfirm });
  };

  const closeModal = () => {
    setModal({ ...modal, isOpen: false });
  };

  // ✅ Fonction pour reset quotas
  const resetQuotas = async (type, typeName) => {
    // eslint-disable-next-line no-restricted-globals
    if (!confirm(`⚠️ Réinitialiser ${typeName} ?\n\nCela va :\n- Archiver les éléments existants\n- Mettre les quotas à 0/0\n\nConfirmer ?`)) {
      return;
    }
    
    try {
      const response = await fetch(`${API_URL}/api/admin/clients/${clientId}/quotas/reset`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ type })
      });
      
      if (response.ok) {
        const data = await response.json();
        // Recharger AVANT l'alert
        await loadGenerated();
        await loadVideos();
        await loadQuotas();
        showModal('✅ Reset réussi', `${data.reset_count} éléments archivés. Quotas remis à 0/0`, 'success');
      } else {
        showModal('❌ Erreur', 'Erreur lors du reset', 'error');
      }
    } catch (error) {
      console.error('Erreur reset:', error);
      showModal('❌ Erreur', 'Erreur réseau', 'error');
    }
  };

  useEffect(() => {
    if (clientId) {
      loadModels();
      loadProducts();
      loadGenerated();
      loadStats();
      loadVideos();
      loadQuotas();
      
      // Rafraîchir quotas toutes les 30s
      const interval = setInterval(loadQuotas, 30000);
      return () => clearInterval(interval);
    }
  }, [clientId]);

  // Charger vidéos universal uniquement
  const loadVideos = async () => {
    try {
      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/videos`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setVideos(data.videos || []);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };


  // ✅ COMPOSANT HEADER FIXE (navigation + quotas)
  const HeaderNavigation = () => (
    <div className="sticky top-0 z-50 bg-gradient-to-br from-slate-950 via-cyan-950 to-slate-950 border-b border-white/10 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto">
        {/* Quotas */}
        <div className="p-4">
          <QuotasHeader />
        </div>
        
        {/* Navigation */}
        <div className="flex items-center gap-4 p-4">
          <button
            onClick={onBack}
            className="px-4 py-2 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:scale-105 transition-all flex items-center gap-2"
          >
            <ArrowLeft className="w-5 h-5" />
            Retour
          </button>

          <button
            onClick={() => {
              loadVideos();
              setView('videos');
            }}
            className="px-4 py-2 rounded-xl bg-gradient-to-r from-green-600 to-emerald-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
          >
            🎥 Vidéos ({videos.length})
          </button>

          <button
            onClick={() => setView('publish')}
            className="px-4 py-2 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
          >
            <ImageIcon className="w-5 h-5" />
            Images ({generated.length})
          </button>

          <button
            onClick={() => setView('generate')}
            className="px-4 py-2 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
          >
            <Sparkles className="w-5 h-5" />
            Générer
          </button>
        </div>
      </div>
    </div>
  );

  const QuotasHeader = () => {
    const imagesRemaining = quotas.remaining_images || 0;
    const videosRemaining = quotas.remaining_videos || 0;
    
    const getColorClass = (used, max) => {
      if (max === 0) return 'from-gray-600 to-gray-700';
      const remaining = max - used;
      if (remaining === 0) return 'from-red-600 to-rose-600';
      if (remaining <= 5) return 'from-yellow-600 to-orange-600';
      return 'from-green-600 to-emerald-600';
    };
  
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        {/* Images */}
        <div className={`bg-gradient-to-r ${getColorClass(quotas.used_images, quotas.max_images)} rounded-xl p-4 shadow-lg`}>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <ImageIcon className="w-5 h-5 text-white" />
              <span className="text-white font-bold text-sm">Images Pub</span>
            </div>
            {imagesRemaining <= 5 && imagesRemaining > 0 && (
              <AlertCircle className="w-4 h-4 text-white animate-pulse" />
            )}
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-white/90 text-xs">Générées</span>
              <span className="text-white font-bold text-lg">{quotas.used_images}</span>
            </div>
            <div className="h-2 bg-white/20 rounded-full overflow-hidden">
              <div 
                className="h-full bg-white transition-all duration-500"
                style={{ width: `${quotas.max_images > 0 ? (quotas.used_images / quotas.max_images) * 100 : 0}%` }}
              />
            </div>
            <div className="text-white/80 text-xs text-center">
              {imagesRemaining} / {quotas.max_images} restantes
            </div>
          </div>
        </div>
  
        {/* Vidéos */}
        <div className={`bg-gradient-to-r ${getColorClass(quotas.used_videos, quotas.max_videos)} rounded-xl p-4 shadow-lg`}>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <Video className="w-5 h-5 text-white" />
              <span className="text-white font-bold text-sm">Vidéos Pub</span>
            </div>
            {videosRemaining <= 5 && videosRemaining > 0 && (
              <AlertCircle className="w-4 h-4 text-white animate-pulse" />
            )}
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-white/90 text-xs">Générées</span>
              <span className="text-white font-bold text-lg">{quotas.used_videos}</span>
            </div>
            <div className="h-2 bg-white/20 rounded-full overflow-hidden">
              <div 
                className="h-full bg-white transition-all duration-500"
                style={{ width: `${quotas.max_videos > 0 ? (quotas.used_videos / quotas.max_videos) * 100 : 0}%` }}
              />
            </div>
            <div className="text-white/80 text-xs text-center">
              {videosRemaining} / {quotas.max_videos} restantes
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Supprimer vidéo
  const deleteVideo = async (videoId) => {
    setModal({
      isOpen: true,
      title: 'Supprimer la vidéo',
      message: 'Êtes-vous sûr de vouloir supprimer cette vidéo définitivement ?',
      type: 'warning',
      onConfirm: async () => {
        setLoading(true);
        try {
          const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/videos/${videoId}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
          });

          if (response.ok) {
            await loadVideos();
            showModal('Succès', 'Vidéo supprimée avec succès', 'success');
          } else {
            const data = await response.json();
            showModal('Erreur', data.message || 'Erreur suppression', 'error');
          }
        } catch (error) {
          showModal('Erreur', 'Erreur réseau', 'error');
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const deleteGenerated = async (generatedId) => {
    setModal({
      isOpen: true,
      title: 'Supprimer l\'image',
      message: 'Êtes-vous sûr de vouloir supprimer cette image générée définitivement ?',
      type: 'warning',
      onConfirm: async () => {
        setLoading(true);
        try {
          const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/generated/${generatedId}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
          });
  
          if (response.ok) {
            await loadGenerated();
            await loadStats();
            showModal('Succès', 'Image supprimée avec succès', 'success');
          } else {
            const data = await response.json();
            showModal('Erreur', data.message || 'Erreur suppression', 'error');
          }
        } catch (error) {
          showModal('Erreur', 'Erreur réseau', 'error');
        } finally {
          setLoading(false);
        }
      }
    });
  };

  // ✅ CORRECTION: Pas de useCallback
  const handleVideoConfigChange = (field, value) => {
    setVideoConfig(prev => ({...prev, [field]: value}));
  };

  // ✅ NOUVELLE FONCTION: Fusionner vidéos
  const mergeVideos = async () => {
    if (selectedVideosForMerge.length < 2) {
      showModal('Attention', 'Sélectionnez au moins 2 vidéos', 'warning');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/videos/merge`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          video_ids: selectedVideosForMerge.map(v => v.$id)
        })
      });

      if (response.ok) {
        showModal('Succès', 'Vidéos fusionnées avec succès !', 'success');
        await loadVideos();
        setSelectedVideosForMerge([]);
      } else {
        const data = await response.json();
        showModal('Erreur', data.message || 'Erreur fusion', 'error');
      }
    } catch (error) {
      showModal('Erreur', 'Erreur réseau', 'error');
    } finally {
      setLoading(false);
    }
  };

  // ✅ NOUVELLE FONCTION: Publier vidéo
  const publishVideo = async () => {
    if (!selectedVideoForPublish || !videoPublishCaption.trim()) {
      showModal('Attention', 'Texte de publication requis', 'warning');
      return;
    }

    setIsPublishingVideo(true);
    try {
      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/videos/${selectedVideoForPublish.$id}/publish`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ caption: videoPublishCaption })
      });

      if (response.ok) {
        const data = await response.json();
        showModal('Succès', 'Vidéo publiée sur Facebook !', 'success');
        await loadVideos();
        setShowPublishVideoModal(false);
        setSelectedVideoForPublish(null);
        setVideoPublishCaption('');
      } else {
        const data = await response.json();
        showModal('Erreur', data.message || 'Erreur publication', 'error');
      }
    } catch (error) {
      showModal('Erreur', 'Erreur réseau', 'error');
    } finally {
      setIsPublishingVideo(false);
    }
  };

  const loadStats = async () => {
    try {
      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/stats`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setStats(data);
      }
    } catch (error) {
      console.error('Error loading stats:', error);
    }
  };

  const CustomLoader = () => (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-[150]">
      <div className="text-center">
        <img 
          src="/TeckiA-logo.gif" 
          alt="Loading" 
          className="w-32 h-32 mx-auto mb-4 animate-pulse"
        />
        <div className="flex items-center gap-2 justify-center">
          <Loader2 className="w-6 h-6 text-cyan-500 animate-spin" />
          <p className="text-white text-lg font-medium">Traitement en cours...</p>
        </div>
      </div>
    </div>
  );

  const Modal = ({ isOpen, onClose, title, message, type = 'info', onConfirm }) => {
    if (!isOpen) return null;
  
    const colors = {
      success: 'from-green-600 to-emerald-600',
      error: 'from-red-600 to-rose-600',
      warning: 'from-yellow-600 to-orange-600',
      info: 'from-blue-600 to-cyan-600'
    };
  
    const icons = {
      success: '✅',
      error: '❌',
      warning: '⚠️',
      info: 'ℹ️'
    };
  
    return (
      <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
        <div className="bg-slate-900 rounded-3xl max-w-md w-full border border-white/10 shadow-2xl animate-fadeIn">
          <div className={`bg-gradient-to-r ${colors[type]} p-6 rounded-t-3xl`}>
            <div className="flex items-center gap-3">
              <span className="text-4xl">{icons[type]}</span>
              <h3 className="text-xl font-bold text-white">{title}</h3>
            </div>
          </div>
          
          <div className="p-6">
            <p className="text-white/80 text-base whitespace-pre-line">{message}</p>
          </div>
          
          <div className="p-6 pt-0 flex gap-3">
            {onConfirm ? (
              <>
                <button
                  onClick={onClose}
                  className="flex-1 px-6 py-3 rounded-xl bg-white/10 hover:bg-white/20 text-white font-medium transition-all"
                >
                  Annuler
                </button>
                <button
                  onClick={() => {
                    onConfirm();
                    onClose();
                  }}
                  className={`flex-1 px-6 py-3 rounded-xl bg-gradient-to-r ${colors[type]} text-white font-bold hover:scale-105 transition-all`}
                >
                  Confirmer
                </button>
              </>
            ) : (
              <button
                onClick={onClose}
                className={`w-full px-6 py-3 rounded-xl bg-gradient-to-r ${colors[type]} text-white font-bold hover:scale-105 transition-all`}
              >
                OK
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  const PreviewModal = ({ isOpen, onClose, imageUrl, name, date }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black/95 backdrop-blur-sm flex items-center justify-center z-[100] p-4" onClick={onClose}>
        <div className="relative max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
          <button
            onClick={onClose}
            className="absolute -top-12 right-0 text-white/60 hover:text-white transition-colors"
          >
            <X className="w-8 h-8" />
          </button>
          
          <div className="bg-slate-900 rounded-3xl overflow-hidden border border-white/10 shadow-2xl">
            <div className="bg-gradient-to-r from-cyan-600 to-blue-600 p-4">
              <h3 className="text-xl font-bold text-white">{name}</h3>
              {date && (
                <p className="text-white/80 text-sm flex items-center gap-2 mt-1">
                  <Clock className="w-4 h-4" />
                  {new Date(date).toLocaleDateString('fr-FR', { 
                    day: '2-digit', 
                    month: 'long', 
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
              )}
            </div>
            
            <div className="p-4 bg-black">
              <img
                src={imageUrl}
                alt={name}
                className="w-full h-auto max-h-[70vh] object-contain rounded-xl cursor-zoom-in"
                onClick={() => window.open(imageUrl, '_blank')}
              />
            </div>
            
            <div className="p-4 flex flex-wrap gap-3">
            <a
                href={imageUrl}
                download
                className="flex-1 px-6 py-3 rounded-xl bg-gradient-to-r from-cyan-600 to-blue-600 text-white font-bold hover:scale-105 transition-all flex items-center justify-center gap-2 min-w-[120px]"
              >
                <Download className="w-5 h-5" />
                Télécharger
              </a>
              <button
                onClick={() => window.open(imageUrl, '_blank')}
                className="px-6 py-3 rounded-xl bg-white/10 hover:bg-white/20 text-white font-medium transition-all flex items-center gap-2"
              >
                <ZoomIn className="w-5 h-5" />
                Plein écran
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Modal de configuration vidéo
  const VideoConfigModal = () => {
    if (!showVideoConfig) return null;
    
    // Récupérer les infos depuis l'image générée
    const generatedImage = generated.find(g => g.$id === videoConfig.generated_id);
    const productName = generatedImage?.product_name || 'Produit';
    const productPrice = generatedImage?.product_price || '';
  
    return (
      <div className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
        <div className="bg-slate-900 rounded-3xl max-w-lg w-full border border-white/10 shadow-2xl">
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-6 rounded-t-3xl">
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-bold text-white">🎥 Générer Vidéo</h3>
              <button onClick={() => setShowVideoConfig(false)} className="text-white/80 hover:text-white">
                <X className="w-6 h-6" />
              </button>
            </div>
          </div>
          
          <div className="p-6 space-y-6">
            {/* Info produit */}
            <div className="bg-white/5 rounded-xl p-4 border border-white/10">
              <p className="text-white/60 text-xs mb-2">📦 Produit:</p>
              <p className="text-white font-bold text-lg">{productName}</p>
              {productPrice && (
                <p className="text-green-400 font-bold mt-1">💎 {productPrice}</p>
              )}
            </div>

            {/* Checkbox texte */}
            <div className="bg-blue-600/10 rounded-xl p-4 border border-blue-500/30">
              <label className="flex items-start gap-3 cursor-pointer">
                <input 
                  type="checkbox"
                  checked={showTitlePriceOnVideo}
                  onChange={(e) => setShowTitlePriceOnVideo(e.target.checked)}
                  className="w-5 h-5 mt-1 rounded"
                />
                <div>
                  <span className="text-white font-bold block">
                    📝 Afficher titre et prix sur la vidéo
                  </span>
                  <p className="text-xs text-white/60 mt-1">
                    Le nom et le prix seront ajoutés élégamment en bas avec ffmpeg
                  </p>
                </div>
              </label>
            </div>

            {/* Résumé */}
            <div className="bg-white/5 rounded-xl p-4 border border-white/10">
              <p className="text-white/60 text-xs mb-2">📊 Résumé:</p>
              <ul className="text-white/80 text-sm space-y-1">
                <li>• Durée: ~5 secondes</li>
                <li>• Effets: Zoom, pan, slow-mo</li>
                <li>• Style: Cinématique 8K</li>
                <li>• Temps: ~60 secondes</li>
              </ul>
            </div>
          </div>
          
          <div className="p-6 pt-0 flex gap-3">
            <button
              onClick={() => setShowVideoConfig(false)}
              className="flex-1 px-6 py-3 rounded-xl bg-white/10 hover:bg-white/20 text-white font-medium transition-all"
            >
              Annuler
            </button>
            <button
              onClick={async () => {
                setShowVideoConfig(false);
                setLoading(true);
                try {
                  const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/generate-video`, {
                    method: 'POST',
                    headers: {
                      'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                      generated_id: videoConfig.generated_id,
                      product_name: productName,
                      product_price: productPrice,
                      show_title_price: showTitlePriceOnVideo  // ✅ Envoyer checkbox
                    })
                  });
                  
                  if (response.ok) {
                    showModal('Succès', '🎥 Vidéo générée !\n\nVoir dans "Vidéos".', 'success');
                    await loadVideos();
                    await loadQuotas();
                    setVideoConfig({ generated_id: null });
                    setShowTitlePriceOnVideo(false);
                  } else {
                    const data = await response.json();
                    showModal('Erreur', data.message || 'Erreur génération', 'error');
                  }
                } catch (error) {
                  showModal('Erreur', 'Erreur réseau', 'error');
                } finally {
                  setLoading(false);
                }
              }}
              className="flex-1 px-6 py-3 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold hover:scale-105 transition-all flex items-center justify-center gap-2"
            >
              <Sparkles className="w-5 h-5" />
              Générer
            </button>
          </div>
        </div>
      </div>
    );
  };

  const loadModels = async () => {
    try {
      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/models`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setModels(data.models || []);
        setMaxModels(data.max_models || 5);
        setCanAddMoreModels(data.can_add_more || false);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const loadProducts = async () => {
    try {
      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/products`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setProducts(data.products || []);
        setMaxProducts(data.max_products || 100);
        setCanAddMoreProducts(data.can_add_more || false);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const loadGenerated = async () => {
    try {
      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/generated`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setGenerated(data.generated || []);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const deleteModel = async (modelId) => {
    setModal({
      isOpen: true,
      title: 'Supprimer le modèle',
      message: 'Êtes-vous sûr de vouloir supprimer ce modèle définitivement ?',
      type: 'warning',
      onConfirm: async () => {
        setLoading(true);
        try {
          const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/models/${modelId}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
          });
  
          if (response.ok) {
            await loadModels();
            showModal('Succès', 'Modèle supprimé avec succès', 'success');
          } else {
            const data = await response.json();
            showModal('Erreur', data.message || 'Erreur suppression', 'error');
          }
        } catch (error) {
          showModal('Erreur', 'Erreur réseau', 'error');
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const deleteProduct = async (productId) => {
    setModal({
      isOpen: true,
      title: 'Supprimer le produit',
      message: 'Êtes-vous sûr de vouloir supprimer ce produit définitivement ?',
      type: 'warning',
      onConfirm: async () => {
        setLoading(true);
        try {
          const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/products/${productId}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
          });
  
          if (response.ok) {
            await loadProducts();
            showModal('Succès', 'Produit supprimé avec succès', 'success');
          } else {
            const data = await response.json();
            showModal('Erreur', data.message || 'Erreur suppression', 'error');
          }
        } catch (error) {
          showModal('Erreur', 'Erreur réseau', 'error');
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleModelFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setModelFormData({
        ...modelFormData,
        file,
        preview: URL.createObjectURL(file),
        name: modelFormData.name || file.name.split('.')[0]
      });
      setShowModelForm(true);
    }
  };

  const submitModelForm = async () => {
    if (!modelFormData.file || !modelFormData.name.trim()) {
      showModal('Attention', 'Veuillez remplir tous les champs requis', 'warning');
      return;
    }

    setUploadLoading(true);

    const formData = new FormData();
    formData.append('model_image', modelFormData.file);
    formData.append('name', modelFormData.name);

    try {
      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/models`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` },
        body: formData
      });

      const data = await response.json();

      if (response.ok) {
        await loadModels();
        setShowModelForm(false);
        setModelFormData({ name: '', file: null, preview: null });
        showModal('Succès', 'Modèle ajouté avec succès !', 'success');
      } else {
        showModal('Erreur', data.message || 'Erreur ajout', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showModal('Erreur', 'Erreur réseau upload', 'error');
    } finally {
      setUploadLoading(false);
    }
  };

  const handleProductFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProductFormData({
        ...productFormData,
        file,
        preview: URL.createObjectURL(file),
        name: productFormData.name || file.name.split('.')[0]
      });
      setShowProductForm(true);
    }
  };

  const submitProductForm = async () => {
    if (!productFormData.file || !productFormData.name.trim()) {
      showModal('Attention', 'Veuillez remplir tous les champs requis', 'warning');
      return;
    }

    setUploadLoading(true);

    const formData = new FormData();
    formData.append('product_image', productFormData.file);
    formData.append('name', productFormData.name);
    formData.append('description', productFormData.description);
    formData.append('price', productFormData.price);

    try {
      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/products`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` },
        body: formData
      });

      const data = await response.json();

      if (response.ok) {
        await loadProducts();
        setShowProductForm(false);
        setProductFormData({ name: '', description: '', price: '', file: null, preview: null });
        showModal('Succès', 'Produit ajouté avec succès !', 'success');
      } else {
        showModal('Erreur', data.message || 'Erreur ajout', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showModal('Erreur', 'Erreur réseau upload', 'error');
    } finally {
      setUploadLoading(false);
    }
  };

  const generateBatch = async () => {
    if ( selectedProducts.length === 0) {
      showModal('Attention', 'Sélectionnez au moins un produit', 'warning');
      return;
    }

    setLoading(true);
    setGeneratingStatus({});

    try {
      const status = {};
      selectedProducts.forEach(id => {
        status[id] = 'processing';
      });
      setGeneratingStatus(status);

      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/generate-batch`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          product_ids: selectedProducts,
          show_title_price: showTitlePriceOnImage
        })
      });

      if (response.ok) {
        const data = await response.json();
        
        const finalStatus = {};
        data.results.forEach(r => {
          finalStatus[r.product_id] = 'completed';
        });
        setGeneratingStatus(finalStatus);
      
        await loadGenerated();
        await loadStats();
        await loadQuotas();
        setView('publish');
        setSelectedProducts([]);
        setSelectedModel(null);
        showModal('Succès', `${data.results.length} image(s) générée(s) avec succès !`, 'success');
      } else {
        const data = await response.json();
        showModal('Erreur', data.message || 'Erreur génération', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showModal('Erreur', 'Erreur réseau génération', 'error');
    } finally {
      setLoading(false);
    }
  };

  const autoPublishToFacebook = async () => {
    if (selectedGenerated.length === 0) {
      showModal('Attention', 'Sélectionnez au moins une image', 'warning');
      return;
    }

    setAutoPublishing(true);

    try {
      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/auto-publish`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          generated_ids: selectedGenerated
        })
      });
      if (response.ok) {
        const data = await response.json();
        showModal(
          'Publication réussie !',
          `📝 Texte généré:\n${data.caption}\n\n🔗 Lien: ${data.post_url}`,
          'success'
        );
        setSelectedGenerated([]);
        setView('manage');
      } else {
        const data = await response.json();
        showModal('Erreur', data.message || 'Erreur publication', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showModal('Erreur', 'Erreur réseau publication', 'error');
    } finally {
      setAutoPublishing(false);
    }
  };

  // Composant pour bouton retour fixe
  const BackButton = () => (
    <button
      onClick={() => setView('manage')}
      className="fixed top-4 left-4 z-50 flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:scale-105 transition-all shadow-lg"
    >
      <ArrowLeft className="w-5 h-5" />
      <span className="hidden sm:inline">Retour</span>
    </button>
  );

  // VIEW: Gestion
  if (view === 'manage') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-cyan-950 to-slate-950">
       
        <div className="max-w-6xl mx-auto">
        <header className="border-b border-white/10 bg-black/30 backdrop-blur-xl sticky top-0 z-40 mb-6">
          <div className="container mx-auto px-4 py-4 md:py-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <img 
                  src="/TeckiA-logo.gif" 
                  alt="TeckiA IA" 
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
                />
                <div>
                  <h1 className="text-base md:text-xl font-bold text-white flex items-center gap-2">
                    TeckiA Fashion Glow
                  </h1>
                  <p className="text-xs md:text-sm text-cyan-200">
                    Produits Tech, Alimentaire & Plus
                  </p>
                </div>
              </div>
              <img 
                src="/Teckia-smil.png" 
                alt="TeckiA" 
                className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
              />
            </div>
          </div>
          <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
            <button
              onClick={onBack}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:scale-105 transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
              Retour
            </button>

            <div className="flex items-center flex-wrap gap-4">
              <button
                onClick={() => {
                  loadVideos();
                  setView('videos');
                }}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-green-600 to-emerald-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                🎥({videos.length})
              </button>

              <button
                onClick={() => setView('publish')}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                <ImageIcon className="w-5 h-5" />
                ({generated.length})
              </button>

              <button
                onClick={() => {
                  if (models.length === 0) {
                    showModal('Attention', 'Ajoutez au moins 1 modèle', 'warning');
                    return;
                  }
                  if (products.length === 0) {
                    showModal('Attention', 'Ajoutez au moins 1 produit', 'warning');
                    return;
                  }
                  setView('generate');
                }}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                <Sparkles className="w-5 h-5" />
                Générer
              </button>
            </div>
          </div>
        </header>

        {/* Stats Section */}
        <div className="max-w-7xl mx-auto mb-6">
        <QuotasHeader />
        
        {/* Boutons Reset Quotas */}
      
        </div>

        <div className="max-w-7xl mx-auto">
          

          <div className=" md:grid-cols-2 gap-8">
            

            {/* PRODUITS */}
            <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl sm:text-2xl font-bold text-white flex items-center gap-3">
                  <Sparkles className="w-6 h-6 text-blue-400" />
                  📤 Uploader vos Produits ({products.length}/{maxProducts})
                </h2>
                {!canAddMoreProducts && (
                  <span className="text-xs bg-red-500/20 text-red-300 px-3 py-1 rounded-full">
                    Max atteint
                  </span>
                )}
              </div>

              {canAddMoreProducts && !showProductForm && (
                <label className="block mb-6 cursor-pointer">
                  <div className="border-2 border-dashed border-blue-500/50 rounded-2xl p-8 hover:border-blue-500 transition-all text-center bg-white/5">
                    <Upload className="w-12 h-12 text-blue-400 mx-auto mb-3" />
                    <p className="text-white mb-2">Ajoutez un produit</p>
                    <p className="text-white/60 text-sm">Image, nom, description, prix</p>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={handleProductFileChange}
                  />
                </label>
              )}

              {showProductForm && (
                <div className="mb-6 bg-white/10 rounded-2xl p-6 border border-blue-500/50">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-bold text-white">Nouveau Produit</h3>
                    <button
                      onClick={() => {
                        setShowProductForm(false);
                        setProductFormData({ name: '', description: '', price: '', file: null, preview: null });
                      }}
                      className="text-white/60 hover:text-white"
                    >
                      <X className="w-5 h-5" />
                    </button>
                  </div>

                  {productFormData.preview && (
                    <img
                      src={productFormData.preview}
                      alt="Preview"
                      className="w-full h-48 object-cover rounded-xl mb-4"
                    />
                  )}

                  <div className="space-y-4">
                    <div>
                      <label className="block text-white/80 text-sm mb-2">Nom du produit *</label>
                      <input
                        type="text"
                        value={productFormData.name}
                        onChange={(e) => setProductFormData({...productFormData, name: e.target.value})}
                        placeholder="Ex: iPhone 15 Pro Max"
                        className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/40 focus:outline-none focus:border-blue-500"
                      />
                    </div>


                    <div>
                      <label className="block text-white/80 text-sm mb-2">Prix</label>
                      <input
                        type="text"
                        value={productFormData.price}
                        onChange={(e) => setProductFormData({...productFormData, price: e.target.value})}
                        placeholder="Ex: 1 500 000 Ar"
                        className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/40 focus:outline-none focus:border-blue-500"
                      />
                    </div>

                    <button
                      onClick={submitProductForm}
                      disabled={uploadLoading || !productFormData.name.trim()}
                      className="w-full px-6 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    >
                      {uploadLoading ? (
                        <>
                          <Loader2 className="w-5 h-5 animate-spin" />
                          Ajout en cours...
                        </>
                      ) : (
                        <>
                          <Check className="w-5 h-5" />
                          Ajouter le produit
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-h-[400px] overflow-y-auto pr-2">
                {products.map(product => (
                  <div key={product.$id} className="bg-white/5 rounded-xl overflow-hidden border border-white/10 hover:border-blue-500 transition-all relative group">
                    <img
                      src={`${API_URL}${product.image_url}`}
                      alt={product.name}
                      className="w-full h-48 object-cover"
                    />
                    <div className="p-3">
                      <p className="text-white text-sm font-medium truncate">{product.name}</p>
                      {product.price && (
                        <p className="text-green-400 text-xs font-bold flex items-center gap-1 mt-1">
                          <DollarSign className="w-3 h-3" />
                          {product.price}
                        </p>
                      )}
                      {product.description && (
                        <p className="text-white/60 text-xs mt-1 truncate">{product.description}</p>
                      )}
                    </div>
                    
                    <button
                      onClick={() => deleteProduct(product.$id)}
                      className="absolute top-2 right-2 bg-red-500/80 hover:bg-red-600 p-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity"
                    >
                      <Trash2 className="w-4 h-4 text-white" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <Modal {...modal} onClose={closeModal} />
        <VideoConfigModal />
        {(loading || uploadLoading) && <CustomLoader />}
      </div>
      </div>
    );
  }

  // VIEW: Vidéos
  if (view === 'videos') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-slate-950 p-4 md:p-8">
        
        <div className="max-w-6xl mx-auto">
        <header className="border-b border-white/10 bg-black/30 backdrop-blur-xl sticky top-0 z-40 mb-6">
          <div className="container mx-auto px-4 py-4 md:py-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <img 
                  src="/TeckiA-logo.gif" 
                  alt="TeckiA IA" 
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
                />
                <div>
                  <h1 className="text-base md:text-xl font-bold text-white flex items-center gap-2">
                    TeckiA Fashion Glow
                  </h1>
                  <p className="text-xs md:text-sm text-cyan-200">
                    Produits Tech, Alimentaire & Plus
                  </p>
                </div>
              </div>
              <img 
                src="/Teckia-smil.png" 
                alt="TeckiA" 
                className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
              />
            </div>
          </div>
          <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
            <button
              onClick={onBack}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:scale-105 transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
              Retour
            </button>

            <div className="flex items-center flex-wrap gap-4">
              <button
                onClick={() => {
                  loadVideos();
                  setView('videos');
                }}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-green-600 to-emerald-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                🎥({videos.length})
              </button>

              <button
                onClick={() => setView('publish')}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                <ImageIcon className="w-5 h-5" />
                ({generated.length})
              </button>

              <button
                onClick={() => {
                  if (models.length === 0) {
                    showModal('Attention', 'Ajoutez au moins 1 modèle', 'warning');
                    return;
                  }
                  if (products.length === 0) {
                    showModal('Attention', 'Ajoutez au moins 1 produit', 'warning');
                    return;
                  }
                  setView('generate');
                }}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                <Sparkles className="w-5 h-5" />
                Générer
              </button>
            </div>
          </div>
        </header>
          
          <div className="text-center mb-12 pt-16">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              🎥 Vidéos Publicitaires Universal
            </h1>
            <p className="text-xl text-purple-200">
              {videos.length} vidéo{videos.length > 1 ? 's' : ''} générée{videos.length > 1 ? 's' : ''}
            </p>
          </div>
          
          <QuotasHeader />
          {/* ✅ BARRE ACTIONS VIDÉOS */}
          {selectedVideosForMerge.length > 0 && (
            <div className="mb-8 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl p-6 border border-white/20">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold text-white">
                  {selectedVideosForMerge.length} vidéo(s) sélectionnée(s)
                </h3>
                <button
                  onClick={() => setSelectedVideosForMerge([])}
                  className="px-4 py-2 rounded-lg bg-white/20 hover:bg-white/30 text-white transition-all"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              <div className="flex gap-3">
                {selectedVideosForMerge.length >= 2 && (
                  <button
                    onClick={mergeVideos}
                    className="flex-1 px-6 py-3 rounded-xl bg-white text-purple-600 font-bold hover:scale-105 transition-all flex items-center justify-center gap-2"
                  >
                    🎬 Fusionner {selectedVideosForMerge.length} vidéos
                  </button>
                )}
                {selectedVideosForMerge.length === 1 && (
                  <button
                    onClick={() => {
                      setSelectedVideoForPublish(selectedVideosForMerge[0]);
                      setShowPublishVideoModal(true);
                    }}
                    className="flex-1 px-6 py-3 rounded-xl bg-white text-purple-600 font-bold hover:scale-105 transition-all flex items-center justify-center gap-2"
                  >
                    <Facebook className="w-5 h-5" />
                    Publier sur Facebook
                  </button>
                )}
              </div>
            </div>
          )}
          

          {/* ✅ MODAL PUBLICATION VIDÉO */}
        {showPublishVideoModal && (
          <div className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-[200] p-4">
            <div className="bg-slate-900 rounded-2xl p-8 max-w-md w-full border border-white/10">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
                <Facebook className="w-7 h-7 text-blue-500" />
                Publier sur Facebook
              </h3>
              
              <div className="mb-6">
                <label className="block text-white/80 mb-2 font-medium">Texte de publication</label>
                <textarea
                  value={videoPublishCaption}
                  onChange={(e) => setVideoPublishCaption(e.target.value)}
                  placeholder="Saisissez le texte de votre publication..."
                  rows={4}
                  className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="flex gap-4">
                <button
                  onClick={() => {
                    setShowPublishVideoModal(false);
                    setVideoPublishCaption('');
                    setSelectedVideoForPublish(null);
                  }}
                  className="flex-1 px-6 py-3 rounded-xl bg-white/10 text-white hover:bg-white/20 transition-all"
                >
                  Annuler
                </button>
                <button
                  onClick={publishVideo}
                  disabled={isPublishingVideo || !videoPublishCaption.trim()}
                  className="flex-1 px-6 py-3 rounded-xl bg-blue-600 text-white font-bold hover:bg-blue-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {isPublishingVideo ? (
                    <>
                      <Loader2 className="w-5 h-5 animate-spin" />
                      Publication...
                    </>
                  ) : (
                    <>
                      <Facebook className="w-5 h-5" />
                      Publier
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

          {videos.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-white/60 text-lg mb-4">Aucune vidéo générée pour le moment</p>
              <button
                onClick={() => setView('publish')}
                className="px-6 py-3 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold hover:scale-105 transition-all"
              >
                Générer des vidéos depuis les images
              </button>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8 max-h-[70vh] overflow-y-auto pr-2">
                {videos.map(video => {
                  return (
                    <div
                      key={video.$id}
                      className="bg-white/5 backdrop-blur-xl border-2 rounded-2xl overflow-hidden transition-all hover:scale-105 border-white/10 relative"
                    >
                      {/* ✅ CHECKBOX SÉLECTION */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (selectedVideosForMerge.find(v => v.$id === video.$id)) {
                              setSelectedVideosForMerge(selectedVideosForMerge.filter(v => v.$id !== video.$id));
                            } else {
                              setSelectedVideosForMerge([...selectedVideosForMerge, video]);
                            }
                          }}
                          className={`absolute top-2 left-2 z-10 w-8 h-8 rounded-lg flex items-center justify-center transition-all ${
                            selectedVideosForMerge.find(v => v.$id === video.$id)
                              ? 'bg-blue-600'
                              : 'bg-white/20 hover:bg-white/30 border-2 border-white/50'
                          }`}
                        >
                          {selectedVideosForMerge.find(v => v.$id === video.$id) ? (
                            <Check className="w-5 h-5 text-white" />
                          ) : (
                            <span className="text-white/70">📹</span>
                          )}
                        </button>

                        <div className="relative bg-black">
                          {videoLoading[video.$id] && (
                            <div className="absolute inset-0 flex items-center justify-center bg-black/80">
                              <Loader2 className="w-8 h-8 text-purple-400 animate-spin" />
                            </div>
                          )}
                          
                          <video
                            src={`${API_URL}${video.video_url}`}
                            className="w-full h-64 object-cover"
                            controls
                            onLoadStart={() => setVideoLoading({...videoLoading, [video.$id]: true})}
                            onLoadedData={() => setVideoLoading({...videoLoading, [video.$id]: false})}
                            onClick={(e) => e.stopPropagation()}
                          />
                          
                          {video.with_audio && (
                            <div className="absolute top-3 left-3 bg-pink-500 rounded-full px-3 py-1 pointer-events-none">
                              <span className="text-white text-xs font-bold">🔊 Audio</span>
                            </div>
                          )}
                        </div>

                        <div className="p-4">
                          <p className="text-white font-medium mb-2">{video.product_name}</p>
                          <div className="flex items-center gap-2 text-white/60 text-sm mb-3">
                            <Clock className="w-4 h-4" />
                            <span>{video.duration}</span>
                          </div>
                          
                          {video.created_at && (
                            <p className="text-white/40 text-xs flex items-center gap-1 mb-3">
                              {new Date(video.created_at).toLocaleDateString('fr-FR', {
                                day: '2-digit',
                                month: 'short',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </p>
                          )}

                          <div className="flex gap-2">
                          <a
                              href={`${API_URL}${video.video_url}`}
                              download
                              onClick={(e) => e.stopPropagation()}
                              className="flex-1 px-4 py-2 rounded-lg bg-blue-500/20 hover:bg-blue-500/30 text-blue-300 text-center text-sm transition-all flex items-center justify-center gap-2"
                            >
                              <Download className="w-4 h-4" />
                              Télécharger
                            </a>

                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                deleteVideo(video.$id);
                              }}
                              className="px-4 py-2 rounded-lg bg-red-500/20 hover:bg-red-500/30 text-red-300 text-sm transition-all flex items-center justify-center gap-2"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
  
                {/* SECTION PUBLICATION VIDÉOS */}
                {selectedGenerated.length > 0 && (
                  <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-6 lg:p-8">
                    <h2 className="text-2xl font-bold text-white mb-6 text-center">
                      Publier sur Facebook
                    </h2>
  
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <button
                        onClick={autoPublishToFacebook}
                        disabled={autoPublishing}
                        className="px-8 py-6 rounded-2xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold text-lg hover:scale-105 transition-all disabled:opacity-50 flex flex-col items-center justify-center gap-3"
                      >
                        {autoPublishing ? (
                          <>
                            <Loader2 className="w-8 h-8 animate-spin" />
                            Publication...
                          </>
                        ) : (
                          <>
                            <Zap className="w-8 h-8" />
                            <div>Publication AUTO</div>
                            <div className="text-sm opacity-80">TeckiA génère le texte</div>
                          </>
                        )}
                      </button>
  
                      <button
                        onClick={() => {
                          const form = document.getElementById('manual-publish-form-video');
                          form.style.display = form.style.display === 'none' ? 'block' : 'none';
                        }}
                        className="px-8 py-6 rounded-2xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold text-lg hover:scale-105 transition-all flex flex-col items-center justify-center gap-3"
                      >
                        <Facebook className="w-8 h-8" />
                        <div>Publication Manuel</div>
                      </button>
                    </div>
  
                    <div id="manual-publish-form-video" style={{ display: 'none' }} className="mt-8">
                      <textarea
                        value={publishCaption}
                        onChange={(e) => setPublishCaption(e.target.value)}
                        placeholder="Écrivez votre texte de publication..."
                        className="w-full h-32 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/40 focus:outline-none focus:border-purple-500 mb-4"
                      ></textarea>
  
                      <button
                        onClick={() => {
                          showModal('Info', 'Publication vidéo manuelle à venir', 'info');
                        }}
                        disabled={loading}
                        className="w-full px-8 py-4 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold hover:scale-105 transition-all"
                      >
                        <Facebook className="w-6 h-6 inline mr-2" />
                        Publier maintenant
                      </button>
                    </div>
  
                    <div className="mt-6 text-center">
                      <p className="text-white/60 text-sm">
                        {selectedGenerated.length} vidéo{selectedGenerated.length > 1 ? 's' : ''} sélectionnée{selectedGenerated.length > 1 ? 's' : ''}
                      </p>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
  
          <Modal {...modal} onClose={closeModal} />
          {loading && <CustomLoader />}
        </div>
      );
    }  

  if (view === 'generate') {
      return (
        <div className="min-h-screen bg-gradient-to-br from-slate-950 via-cyan-950 to-slate-950 p-4 md:p-8">
          
          <div className="max-w-6xl mx-auto">
          <header className="border-b border-white/10 bg-black/30 backdrop-blur-xl sticky top-0 z-40 mb-6">
          <div className="container mx-auto px-4 py-4 md:py-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <img 
                  src="/TeckiA-logo.gif" 
                  alt="TeckiA IA" 
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
                />
                <div>
                  <h1 className="text-base md:text-xl font-bold text-white flex items-center gap-2">
                    TeckiA Fashion Glow
                  </h1>
                  <p className="text-xs md:text-sm text-cyan-200">
                    Produits Tech, Alimentaire & Plus
                  </p>
                </div>
              </div>
              <img 
                src="/Teckia-smil.png" 
                alt="TeckiA" 
                className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
              />
            </div>
          </div>
          <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
            <button
              onClick={onBack}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:scale-105 transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
              Retour
            </button>

            <div className="flex items-center flex-wrap gap-4">
              <button
                onClick={() => {
                  loadVideos();
                  setView('videos');
                }}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-green-600 to-emerald-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                🎥({videos.length})
              </button>

              <button
                onClick={() => setView('publish')}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                <ImageIcon className="w-5 h-5" />
                ({generated.length})
              </button>

              <button
                onClick={() => {
                  if (models.length === 0) {
                    showModal('Attention', 'Ajoutez au moins 1 modèle', 'warning');
                    return;
                  }
                  if (products.length === 0) {
                    showModal('Attention', 'Ajoutez au moins 1 produit', 'warning');
                    return;
                  }
                  setView('generate');
                }}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                <Sparkles className="w-5 h-5" />
                Générer
              </button>
            </div>
          </div>
        </header>
            
            <div className="text-center mb-12 pt-16">
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
                ✨ Générer Images Publicitaires
              </h1>
              <p className="text-xl text-cyan-200">
                L'IA crée des mises en scène professionnelles
              </p>
            </div>
            <QuotasHeader />
            <div className=" md:grid-cols-2 gap-8 mb-8">             
  
              {/* Sélection Produits */}
              <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-6">
                <h2 className="text-xl md:text-2xl font-bold text-white mb-6">
                ✅ Selectionner vos produits à Embellir
                </h2>
  
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-h-[500px] overflow-y-auto pr-2">
                  {products.map(product => {
                    const isSelected = selectedProducts.includes(product.$id);
                    const status = generatingStatus[product.$id];
  
                    return (
                      <button
                        key={product.$id}
                        onClick={() => {
                          if (isSelected) {
                            setSelectedProducts(selectedProducts.filter(id => id !== product.$id));
                          } else {
                            setSelectedProducts([...selectedProducts, product.$id]);
                          }
                        }}
                        className={`rounded-xl overflow-hidden border-2 transition-all relative ${
                          isSelected
                            ? 'border-blue-500 scale-105'
                            : 'border-white/10 hover:border-blue-500/50'
                        }`}
                      >
                        <img
                          src={`${API_URL}${product.image_url}`}
                          alt={product.name}
                          className="w-full h-48 object-cover"
                        />
                        <div className="p-3 bg-black/50">
                          <p className="text-white text-sm font-medium truncate">{product.name}</p>
                          {product.price && (
                            <p className="text-green-400 text-xs font-bold">{product.price}</p>
                          )}
                        </div>
  
                        {status === 'completed' && (
                          <div className="absolute inset-0 bg-green-500/20 flex items-center justify-center">
                            <CheckCircle className="w-12 h-12 text-green-400" />
                          </div>
                        )}
  
                        {isSelected && !status && (
                          <CheckCircle className="w-5 h-5 text-blue-400 absolute top-2 right-2" />
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
  
            <div className="text-center">
              <div className="mb-6 flex items-center justify-center gap-3 bg-white/5 backdrop-blur-xl rounded-2xl p-4 border border-white/10">
              <input
                type="checkbox"
                checked={showTitlePriceOnImage}
                onChange={(e) => setShowTitlePriceOnImage(e.target.checked)}
                className="w-5 h-5 rounded border-white/20 text-cyan-600 focus:ring-cyan-500"
              />
                <label htmlFor="showDescription" className="text-white cursor-pointer">
                  Afficher le nom et prix du produit
                </label>
              </div>
  
              <button
                onClick={generateBatch}
                disabled={loading || selectedProducts.length === 0}
                className="px-8 py-6 rounded-2xl bg-gradient-to-r from-cyan-600 to-blue-600 text-white font-bold text-lg md:text-xl hover:scale-110 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-3 mx-auto"
              >
                {loading ? (
                  <>
                    <Loader2 className="w-6 h-6 animate-spin" />
                    Génération en cours...
                  </>
                ) : (
                  <>
                    <Sparkles className="w-6 h-6" />
                    Générer {selectedProducts.length} image{selectedProducts.length > 1 ? 's' : ''}
                  </>
                )}
              </button>
  
              <p className="text-white/60 mt-4 text-sm">
                ⏱️ ~20-30 secondes par image • 🎨 Mise en scène automatique par IA
              </p>
  
              {loading && (
                <div className="mt-6 bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10">
                  <div className="flex items-center justify-center gap-3 mb-4">
                    <Loader2 className="w-6 h-6 text-cyan-400 animate-spin" />
                    <p className="text-white font-medium">Génération par TeckiA AI</p>
                  </div>
                  <div className="space-y-2">
                    {selectedProducts.map(productId => {
                      const product = products.find(p => p.$id === productId);
                      const status = generatingStatus[productId];
                      return (
                        <div key={productId} className="flex items-center justify-between bg-white/5 rounded-lg px-4 py-2">
                          <span className="text-white/80 text-sm truncate">{product?.name}</span>
                          {status === 'processing' && (
                            <span className="flex items-center gap-2 text-yellow-400 text-sm">
                              <Loader2 className="w-4 h-4 animate-spin" />
                              En cours...
                            </span>
                          )}
                          {status === 'completed' && (
                            <span className="flex items-center gap-2 text-green-400 text-sm">
                              <CheckCircle className="w-4 h-4" />
                              Terminé
                            </span>
                          )}
                          {!status && (
                            <span className="text-white/40 text-sm">En attente...</span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
  
          <Modal {...modal} onClose={closeModal} />
          {loading && <CustomLoader />}
        </div>
      );
    }
  
    // VIEW: Publication
    if (view === 'publish') {
      return (
        <div className="min-h-screen bg-gradient-to-br from-slate-950 via-cyan-950 to-slate-950 p-4 md:p-8">
          <div className="max-w-6xl mx-auto">
            
            <header className="border-b border-white/10 bg-black/30 backdrop-blur-xl sticky top-0 z-40 mb-6">
          <div className="container mx-auto px-4 py-4 md:py-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <img 
                  src="/TeckiA-logo.gif" 
                  alt="TeckiA IA" 
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
                />
                <div>
                  <h1 className="text-base md:text-xl font-bold text-white flex items-center gap-2">
                    TeckiA Fashion Glow
                  </h1>
                  <p className="text-xs md:text-sm text-cyan-200">
                    Produits Tech, Alimentaire & Plus
                  </p>
                </div>
              </div>
              <img 
                src="/Teckia-smil.png" 
                alt="TeckiA" 
                className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
              />
            </div>
          </div>
          <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
            <button
              onClick={onBack}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:scale-105 transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
              Retour
            </button>

            <div className="flex items-center flex-wrap gap-4">
              <button
                onClick={() => {
                  loadVideos();
                  setView('videos');
                }}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-green-600 to-emerald-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                🎥({videos.length})
              </button>

              <button
                onClick={() => setView('publish')}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                <ImageIcon className="w-5 h-5" />
                ({generated.length})
              </button>

              <button
                onClick={() => {
                  if (models.length === 0) {
                    showModal('Attention', 'Ajoutez au moins 1 modèle', 'warning');
                    return;
                  }
                  if (products.length === 0) {
                    showModal('Attention', 'Ajoutez au moins 1 produit', 'warning');
                    return;
                  }
                  setView('generate');
                }}
                className="px-4 py-3 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold hover:scale-105 transition-all flex items-center gap-2"
              >
                <Sparkles className="w-5 h-5" />
                Générer
              </button>
            </div>
          </div>
        </header>
            
            <div className="text-center mb-12 pt-16">
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
                📱 Visualiser & Publier
              </h1>
              <p className="text-xl text-cyan-200">
                {generated.length} image{generated.length > 1 ? 's' : ''} générée{generated.length > 1 ? 's' : ''}
              </p>
            </div>
            <QuotasHeader />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8 max-h-[65vh] overflow-y-auto pr-2">
              {generated.map(gen => {
                const isSelected = selectedGenerated.includes(gen.$id);
  
                return (
                  <div
                    key={gen.$id}
                    className={`bg-white/5 backdrop-blur-xl border-2 rounded-2xl overflow-hidden transition-all hover:scale-105 ${
                      isSelected ? 'border-green-500' : 'border-white/10 hover:border-green-500/50'
                    }`}
                  >
                    <div className="relative">
                      <img
                        src={`${API_URL}${gen.image_url}`}
                        alt={gen.product_name}
                        className="w-full h-64 object-cover cursor-pointer"
                        onClick={() => {
                          if (isSelected) {
                            setSelectedGenerated(selectedGenerated.filter(id => id !== gen.$id));
                          } else {
                            setSelectedGenerated([...selectedGenerated, gen.$id]);
                          }
                        }}
                      />
                      {isSelected && (
                        <div className="absolute top-3 right-3 bg-green-500 rounded-full p-2 pointer-events-none">
                          <CheckCircle className="w-6 h-6 text-white" />
                        </div>
                      )}
                      
                      <button
                        onClick={() => {
                          setPreviewModal({
                            isOpen: true,
                            imageUrl: `${API_URL}${gen.image_url}`,
                            name: gen.product_name,
                            date: gen.created_at
                          });
                        }}
                        className="absolute top-3 left-3 bg-blue-500/80 hover:bg-blue-600 p-2 rounded-lg transition-all z-10"
                      >
                        <ZoomIn className="w-5 h-5 text-white" />
                      </button>
                    </div>
                    
                    <div className="p-4">
                      <p className="text-white font-medium mb-1">{gen.product_name}</p>
                      <p className="text-white/60 text-sm">{gen.model_name}</p>
                      {gen.product_price && (
                        <p className="text-green-400 text-sm font-bold mt-1 flex items-center gap-1">
                          <DollarSign className="w-4 h-4" />
                          {gen.product_price}
                        </p>
                      )}
                      {gen.created_at && (
                        <p className="text-white/40 text-xs mt-2 flex items-center gap-1">
                          <Clock className="w-3 h-3" />
                          {new Date(gen.created_at).toLocaleDateString('fr-FR', {
                            day: '2-digit',
                            month: 'short',
                            month: 'short',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </p>
                    )}
                  </div>
                  
                  <div className="px-4 pb-4 flex flex-wrap gap-2">
                    <a 
                      href={`${API_URL}${gen.image_url}`}
                      download
                      className="flex-1 px-3 py-2 rounded-lg bg-blue-500/20 hover:bg-blue-500/30 text-blue-300 text-center text-xs sm:text-sm transition-all flex items-center justify-center gap-2 min-w-[40px]"
                    >
                      <Download className="w-4 h-4" />
                      <span className="hidden sm:inline">Télécharger</span>
                    </a>
                    
                    <button
                      onClick={() => deleteGenerated(gen.$id)}
                      className="px-3 py-2 rounded-lg bg-red-500/20 hover:bg-red-500/30 text-red-300 text-center text-xs sm:text-sm transition-all flex items-center justify-center gap-2 min-w-[40px]"
                    >
                      <Trash2 className="w-4 h-4" />
                      <span className="hidden sm:inline">Supprimer</span>
                    </button>
                    
                    <button
                      onClick={() => {
                        setVideoConfig({
                          generated_id: gen.$id,
                          with_audio: false,
                          product_name: gen.product_name || '',
                          price_display: gen.product_price || '',
                          text_overlay: ''
                        });
                        setShowVideoConfig(true);
                      }}
                      className="flex-1 px-3 py-2 rounded-lg bg-purple-500/20 hover:bg-purple-500/30 text-purple-300 text-xs sm:text-sm transition-all flex items-center justify-center gap-2 min-w-[100px]"
                      title="Vidéo PRO avec configuration"
                    >
                      🎥 Vidéo
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {/* SECTION PUBLICATION AVEC SÉLECTION VIDÉOS */}
          {selectedGenerated.length > 0 && (
            <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-6 lg:p-8">
              <h2 className="text-2xl font-bold text-white mb-6 text-center">
                Publier sur Facebook
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <button
                  onClick={autoPublishToFacebook}
                  disabled={autoPublishing}
                  className="px-6 py-6 rounded-2xl bg-gradient-to-r from-cyan-600 to-blue-600 text-white font-bold text-lg hover:scale-105 transition-all disabled:opacity-50 flex flex-col items-center justify-center gap-3 relative overflow-hidden group"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/20 to-orange-400/20 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  
                  {autoPublishing ? (
                    <>
                      <Loader2 className="w-8 h-8 animate-spin relative z-10" />
                      <div className="text-center relative z-10">
                        <div className="font-bold">Publication en cours...</div>
                        <div className="text-sm opacity-80">Génération du texte avec IA</div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex items-center gap-3 relative z-10">
                        <Zap className="w-8 h-8" />
                        <div className="text-left">
                          <div className="font-bold text-xl">Publication AUTO</div>
                          <div className="text-sm opacity-80">TeckiA génère le texte</div>
                        </div>
                      </div>
                      <div className="text-sm opacity-90 relative z-10 flex items-center gap-2">
                        <Sparkles className="w-4 h-4" />
                        Texte pub optimisé par IA
                      </div>
                    </>
                  )}
                </button>

                <button
                  onClick={() => {
                    const form = document.getElementById('manual-publish-form');
                    form.style.display = form.style.display === 'none' ? 'block' : 'none';
                  }}
                  className="px-6 py-6 rounded-2xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold text-lg hover:scale-105 transition-all flex flex-col items-center justify-center gap-3"
                >
                  <div className="flex items-center gap-3">
                    <Facebook className="w-8 h-8" />
                    <div className="text-left">
                      <div className="font-bold text-xl">Publication Manuel</div>
                      <div className="text-sm opacity-80">Écrivez votre texte</div>
                    </div>
                  </div>
                </button>
              </div>

              <div id="manual-publish-form" style={{ display: 'none' }} className="mt-8">
                <textarea
                  value={publishCaption}
                  onChange={(e) => setPublishCaption(e.target.value)}
                  placeholder="Écrivez votre texte de publication..."
                  className="w-full h-32 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/40 focus:outline-none focus:border-cyan-500 mb-4"
                ></textarea>

                <button
                  onClick={async () => {
                    if (!publishCaption.trim()) {
                      showModal('Attention', 'Écrivez un texte de publication', 'warning');
                      return;
                    }

                    setLoading(true);

                    try {
                      const response = await fetch(`${API_URL}/api/clients/${clientId}/marketing/universal/manual-publish`, {
                        method: 'POST',
                        headers: {
                          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                          generated_ids: selectedGenerated,
                          caption: publishCaption
                        })
                      });

                      if (response.ok) {
                        const data = await response.json();
                        showModal('Publication réussie !', `🔗 Lien: ${data.post_url}`, 'success');
                        setSelectedGenerated([]);
                        setPublishCaption('');
                        setView('manage');
                      } else {
                        const data = await response.json();
                        showModal('Erreur', data.message || 'Erreur publication', 'error');
                      }
                    } catch (error) {
                      console.error('Error:', error);
                      showModal('Erreur', 'Erreur réseau', 'error');
                    } finally {
                      setLoading(false);
                    }
                  }}
                  disabled={loading}
                  className="w-full px-8 py-4 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold hover:scale-105 transition-all disabled:opacity-50 flex items-center justify-center gap-3"
                >
                  {loading ? (
                    <>
                      <Loader2 className="w-6 h-6 animate-spin" />
                      Publication...
                    </>
                  ) : (
                    <>
                      <Facebook className="w-6 h-6" />
                      Publier maintenant
                    </>
                  )}
                </button>
              </div>

              <div className="mt-6 text-center">
                <p className="text-white/60 text-sm">
                  {selectedGenerated.length} image{selectedGenerated.length > 1 ? 's' : ''} sélectionnée{selectedGenerated.length > 1 ? 's' : ''}
                </p>
              </div>
            </div>
          )}
        </div>

        <Modal {...modal} onClose={closeModal} />
        <PreviewModal {...previewModal} onClose={() => setPreviewModal({...previewModal, isOpen: false})} />
        <VideoConfigModal />
        
        
        {(loading || autoPublishing) && <CustomLoader />}
      </div>
    );
  }

  return null;
}